var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { tabindex: "-1" } }, [
    _c("input", {
      attrs: { type: "hidden", name: "supplier_invoice_items" },
      domProps: { value: _vm.jsonItems },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "portlet light portlet-fit invoice-details-portlet",
        on: { keydown: _vm.downKeyAdd },
      },
      [
        !_vm.formMode
          ? _c("div", { staticClass: "portlet-title" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _vm.loading
            ? _c("div", [_vm._m(2)])
            : _c("div", [
                _c(
                  "table",
                  {
                    staticClass: "table table-bordered",
                    staticStyle: { "margin-bottom": "5px" },
                    attrs: { id: "invoice-details-table" },
                  },
                  [
                    _c("thead", [
                      _c("tr", [
                        !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                        _vm._v(" "),
                        !_vm.readOnly ? _c("th", [_vm._v(" ")]) : _vm._e(),
                        _vm._v(" "),
                        _c("th", [_vm._v("Pièce")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Description")]),
                        _vm._v(" "),
                        _c("th", { staticClass: "width-min-nowrap" }, [
                          _vm._v("Quantité"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("Prix unitaire")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("Sous-Total")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("T.V. Pneu")]
                        ),
                        _vm._v(" "),
                        _c(
                          "th",
                          { staticClass: "width-min-nowrap text-right" },
                          [_vm._v("Total")]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "draggable",
                      {
                        attrs: { tag: "tbody", handle: ".draggable-handle" },
                        on: { update: _vm.handleChange },
                        model: {
                          value: _vm.items,
                          callback: function ($$v) {
                            _vm.items = $$v
                          },
                          expression: "items",
                        },
                      },
                      _vm._l(_vm.items, function (item, index) {
                        return _c(
                          "tr",
                          { key: index, staticClass: "item-row" },
                          [
                            !_vm.readOnly
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "width-min-nowrap draggable-handle",
                                    staticStyle: {
                                      padding: "3px 8px",
                                      "vertical-align": "middle",
                                      "font-size": "22px",
                                      cursor: "move",
                                    },
                                  },
                                  [
                                    item.part_index === undefined
                                      ? _c("i", { staticClass: "fa fa-bars" })
                                      : _vm._e(),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.readOnly
                              ? _c(
                                  "td",
                                  {
                                    staticClass: "width-min-nowrap text-center",
                                    staticStyle: { padding: "8px" },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-circle btn-icon-only btn-default tooltips mr-0",
                                        attrs: {
                                          "data-container": "body",
                                          "data-placement": "top",
                                          "data-original-title": "Supprimer",
                                          href: "javascript:;",
                                          title: "Supprimer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(index)
                                          },
                                        },
                                      },
                                      [_c("i", { staticClass: "icon-trash" })]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "input",
                                staticStyle: {
                                  width: "350px",
                                  "min-width": "350px",
                                },
                              },
                              [
                                !_vm.readOnly
                                  ? _c(
                                      "div",
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                item.supplier_invoice_item_invoice_id,
                                              expression:
                                                "item.supplier_invoice_item_invoice_id",
                                            },
                                          ],
                                          attrs: { type: "hidden" },
                                          domProps: {
                                            value:
                                              item.supplier_invoice_item_invoice_id,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "supplier_invoice_item_invoice_id",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                item.supplier_invoice_item_service_id,
                                              expression:
                                                "item.supplier_invoice_item_service_id",
                                            },
                                          ],
                                          attrs: { type: "hidden" },
                                          domProps: {
                                            value:
                                              item.supplier_invoice_item_service_id,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "supplier_invoice_item_service_id",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("select-two-items", {
                                          ref: `select2-part-${index}`,
                                          refInFor: true,
                                          attrs: {
                                            endpoint: _vm.partsEndpoint,
                                            type: item.type,
                                            "initial-value": item
                                              .supplier_invoice_item_item.id
                                              ? item.supplier_invoice_item_item.id.toString()
                                              : "",
                                            "initial-display":
                                              item.supplier_invoice_item_item
                                                .text,
                                            "part-number-first": true,
                                            "add-form-base-end-point":
                                              _vm.baseEndpoint + "part/add",
                                            "add-form-title":
                                              "Ajout d'une pièce",
                                            "add-form-selector": "#form_part",
                                            "add-text-input-selector":
                                              "#part_name",
                                            "edit-form-base-end-point":
                                              _vm.baseEndpoint + "part/edit",
                                            "edit-form-title":
                                              "Modifier une pièce",
                                            "edit-form-selector": "#form_part",
                                            "edit-text-input-selector":
                                              "#part_name",
                                            "allow-add": _vm.allowAddParts,
                                            "allow-edit": _vm.allowEditParts,
                                            dropdownParent: _vm.formMode
                                              ? ".modal-supplier_invoice"
                                              : "body",
                                          },
                                          on: {
                                            selected: function ($event) {
                                              return _vm.onSelect(index, $event)
                                            },
                                            clear: function ($event) {
                                              return _vm.onClear(index)
                                            },
                                            onCancel: function ($event) {
                                              return _vm.deleteItemCancel(index)
                                            },
                                          },
                                          model: {
                                            value:
                                              item.supplier_invoice_item_item,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                item,
                                                "supplier_invoice_item_item",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "item.supplier_invoice_item_item",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.supplier_invoice_item_item
                                                .text
                                            ) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "input" }, [
                              !_vm.readOnly
                                ? _c("div", [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            item.supplier_invoice_item_description,
                                          expression:
                                            "item.supplier_invoice_item_description",
                                        },
                                      ],
                                      ref: "description-box",
                                      refInFor: true,
                                      staticClass: "form-control",
                                      staticStyle: {
                                        width: "100%",
                                        "min-height": "35px",
                                        resize: "vertical",
                                      },
                                      domProps: {
                                        value:
                                          item.supplier_invoice_item_description,
                                      },
                                      on: {
                                        change: _vm.handleChange,
                                        input: [
                                          function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item,
                                              "supplier_invoice_item_description",
                                              $event.target.value
                                            )
                                          },
                                          _vm.autoResize,
                                        ],
                                      },
                                    }),
                                  ])
                                : _c("div", {
                                    staticStyle: { padding: "5px" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.supplier_invoice_item_description.replace(
                                          /\n/g,
                                          "<br>"
                                        )
                                      ),
                                    },
                                  }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap input",
                                staticStyle: { width: "100px" },
                              },
                              [
                                _c("div", [
                                  !_vm.readOnly
                                    ? _c("div", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                item.supplier_invoice_item_qty,
                                              expression:
                                                "item.supplier_invoice_item_qty",
                                            },
                                          ],
                                          ref: "qty",
                                          refInFor: true,
                                          staticClass:
                                            "form-control supplier_invoice_item_qty select-on-focus",
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            onFocus: "this.select()",
                                            id: "qty",
                                            type: "number",
                                          },
                                          domProps: {
                                            value:
                                              item.supplier_invoice_item_qty,
                                          },
                                          on: {
                                            change: _vm.handleChange,
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                item,
                                                "supplier_invoice_item_qty",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                item.supplier_invoice_item_qty
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v("\n                  Inventaire: "),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        _vm.itemInventoryCount(item) < 0
                                          ? "font-red"
                                          : "font-black",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.itemInventoryCount(item))
                                      ),
                                    ]
                                  ),
                                  _vm._v("\n                  RT: "),
                                  _c(
                                    "span",
                                    {
                                      class:
                                        _vm.itemReturnCount(item) < 0
                                          ? "font-red"
                                          : "font-black",
                                    },
                                    [_vm._v(_vm._s(_vm.itemReturnCount(item)))]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap input",
                                staticStyle: {
                                  width: "100px",
                                  position: "relative",
                                },
                              },
                              [
                                _c("div", [
                                  !_vm.readOnly
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { position: "relative" },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                position: "absolute",
                                                top: "6px",
                                                right: "8px",
                                                "font-size": "16px",
                                                "user-select": "none",
                                              },
                                            },
                                            [_vm._v("$")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  item.supplier_invoice_item_price,
                                                expression:
                                                  "item.supplier_invoice_item_price",
                                              },
                                            ],
                                            staticClass:
                                              "form-control supplier_invoice_item_price text-right select-on-focus",
                                            staticStyle: {
                                              width: "100px",
                                              "padding-right": "20px",
                                            },
                                            attrs: {
                                              onFocus: "this.select()",
                                              type: "text",
                                            },
                                            domProps: {
                                              value:
                                                item.supplier_invoice_item_price,
                                            },
                                            on: {
                                              change: _vm.handleChange,
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  item,
                                                  "supplier_invoice_item_price",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            padding: "5px",
                                            "text-align": "right",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                item.supplier_invoice_item_price
                                              ) +
                                              " $\n                  "
                                          ),
                                        ]
                                      ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap text-right",
                                staticStyle: { "min-width": "100px" },
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.itemSubTotal(item)) + " $"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap input",
                                staticStyle: {
                                  width: "100px",
                                  position: "relative",
                                },
                              },
                              [
                                !_vm.readOnly
                                  ? _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            top: "8px",
                                            right: "8px",
                                            "font-size": "16px",
                                            "user-select": "none",
                                          },
                                        },
                                        [_vm._v("$")]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              item.supplier_invoice_item_tire_tax,
                                            expression:
                                              "item.supplier_invoice_item_tire_tax",
                                          },
                                        ],
                                        staticClass:
                                          "form-control supplier_invoice_item_tire_tax text-right select-on-focus",
                                        staticStyle: {
                                          width: "100px",
                                          "padding-right": "20px",
                                        },
                                        attrs: {
                                          onFocus: "this.select()",
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            item.supplier_invoice_item_tire_tax,
                                        },
                                        on: {
                                          change: _vm.handleChange,
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              item,
                                              "supplier_invoice_item_tire_tax",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          padding: "5px",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.supplier_invoice_item_tire_tax
                                            ) +
                                            " $\n                "
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "width-min-nowrap text-right",
                                staticStyle: { "min-width": "100px" },
                              },
                              [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.itemTotal(item)) + " $"),
                                ]),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", { staticStyle: { border: "none" } }, [
                      _c("tr", { staticStyle: { border: "none" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: { border: "none" },
                            attrs: { colspan: "6" },
                          },
                          [
                            !_vm.readOnly
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn purple",
                                    attrs: { tabindex: "3" },
                                    on: { click: _vm.addItem },
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-plus" }),
                                    _vm._v(" Ajouter une pièce"),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "none",
                              "padding-right": "0",
                              "padding-bottom": "0",
                            },
                            attrs: { colspan: "5" },
                          },
                          [
                            _c("div", { staticStyle: { float: "right" } }, [
                              _c(
                                "table",
                                { staticClass: "table-bordered text-right" },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [_vm._v("Total sans taxes:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.round(_vm.subtotal, 2)) +
                                            " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [_vm._v("Montant taxable TPS:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.round(_vm.taxableTpsAmount, 2)
                                          ) + " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          "TPS (" +
                                            _vm._s(_vm.tpsValue) +
                                            " %):"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.round(_vm.tpsAmount, 2)) +
                                            " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [_vm._v("Montant taxable TVQ:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.round(_vm.taxableTvqAmount, 2)
                                          ) + " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          "TVQ (" +
                                            _vm._s(_vm.tvqValue) +
                                            " %):"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.round(_vm.tvqAmount, 2)) +
                                            " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      { staticStyle: { padding: "5px" } },
                                      [_vm._v("T.V. Pneu:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          padding: "5px",
                                          "min-width": "100px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.round(_vm.tireTotal, 2)) +
                                            " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          padding: "5px",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [_vm._v("Total:")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: {
                                          padding: "5px",
                                          "min-width": "100px",
                                          "font-weight": "bold",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.round(_vm.grandTotal, 2)) +
                                            " $"
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "caption" }, [
      _c("i", { staticClass: "fa fa-list" }),
      _vm._v(" "),
      _c("span", { staticClass: "caption-subject bold uppercase" }, [
        _vm._v("Pièces"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tools" }, [
      _c("a", {
        staticClass: "collapse",
        attrs: {
          href: "javascript:;",
          "data-original-title": "",
          title: "Afficher / Cacher",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("span", { staticStyle: { "font-size": "22px" } }, [
        _c("i", { staticClass: "fa fa-refresh fa-spin" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }